{
  "fr": {
    "search": {
      "placeholders": {
        "query": "Rechercher des questions ou des mots-clés"
      },
      "title": "Rechercher"
    }
  }
}
